export default __webpack_public_path__ + "static/media/b_historia_small.a8ee9e75.jpg";